"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoAnnotations = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable max-lines-per-function */
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const PlayButton_1 = require("../../atoms/PlayButton");
function VideoAnnotations({ image, videoLink, onFullscreen, }) {
    const [isFullScreen, setIsFullScreen] = (0, react_1.useState)(false);
    const onToggleFullScreen = () => {
        onFullscreen(!isFullScreen);
        setIsFullScreen(!isFullScreen);
    };
    const [isPlaying, setIsPlaying] = (0, react_1.useState)(false);
    const [isOverlayPresent, setIsOverlayPresent] = (0, react_1.useState)(false);
    const videoRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        // Function to check if Model Downloading overlay is present
        const checkOverlayPresence = () => {
            const overlayComponent = document.querySelector('[data-component="ModelDownloadingOverlay"]');
            setIsOverlayPresent(overlayComponent !== null);
        };
        checkOverlayPresence();
        const observer = new MutationObserver(checkOverlayPresence);
        observer.observe(document.body, { childList: true, subtree: true });
        if (isOverlayPresent) {
            if (videoRef.current) {
                videoRef.current.pause();
                setIsPlaying(false);
            }
        }
        // Clean up the observer on unmount
        return () => {
            observer.disconnect();
        };
    }, [isOverlayPresent]);
    const handlePlayButtonClick = () => {
        if (videoRef.current) {
            if (isPlaying) {
                videoRef.current.pause();
            }
            else {
                videoRef.current.play();
            }
            setIsPlaying(!isPlaying);
        }
    };
    const handleWrapperClick = () => {
        if (videoRef.current && isPlaying) {
            videoRef.current.pause();
            setIsPlaying(false);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(Container, { "$isFullScreen": isFullScreen, "data-e2e": 'VideoAnnotations_Container', children: [(0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(PlayButtonWrapper, { onClick: handleWrapperClick, "data-e2e": 'VideoAnnotations_PlayButtonWrapper', children: (0, jsx_runtime_1.jsx)(PlayButton_1.PlayButton, { isPlaying: isPlaying, onClick: handlePlayButtonClick, "data-e2e": 'VideoAnnotations_PlayButton' }) }), (0, jsx_runtime_1.jsx)(StyledVideo, { ref: videoRef, poster: (0, ui_1.fixRelativeUrl)(image), "data-e2e": 'VideoAnnotations_StyledVideo', children: (0, jsx_runtime_1.jsx)("source", { src: (0, ui_1.fixRelativeUrl)(videoLink), type: "video/mp4", "data-e2e": 'VideoAnnotations_source' }) })] }), (0, jsx_runtime_1.jsx)(ButtonsContainer, { "data-e2e": 'VideoAnnotations_ButtonsContainer', children: (0, jsx_runtime_1.jsx)(StyledHide, { onClick: onToggleFullScreen, isSelected: isFullScreen, "data-e2e": 'VideoAnnotations_StyledHide' }) })] }));
}
exports.VideoAnnotations = VideoAnnotations;
const StyledHide = (0, styled_components_1.default)(ui_1.HideButton) `
  background-color: ${({ theme }) => theme.backgroundSenary};
`;
const Container = styled_components_1.default.div `
  position: relative;
  width: 304px;
  border-radius: 4px;
  background-size: cover;
  background-color: ${({ theme }) => theme.backgroundSenary};

  box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.2);

  ${({ $isFullScreen }) => $isFullScreen &&
    (0, styled_components_1.css) `
      display: flex;

      justify-content: center;
      align-content: center;
      flex-wrap: wrap;

      position: fixed !important;

      top: 0 !important;
      left: 0 !important;

      width: 100vw !important;
      height: 100vh !important;

      z-index: 9999 !important;

      margin: 0 !important;
      max-width: unset !important;
      max-height: unset !important;
      background-color: ${({ theme }) => theme.background} !important;
    `}
`;
const PlayButtonWrapper = styled_components_1.default.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  z-index: 1;
`;
const StyledVideo = styled_components_1.default.video `
  width: 100%;
  height: 100%;
`;
const ButtonsContainer = styled_components_1.default.div `
  position: absolute;
  display: flex;
  flex-direction: row;
  top: 10px;
  right: 10px;
  gap: 10px;

  z-index: 99;
`;
